module services {
    export module tariff {
        export class tariffPreferenceCodeService implements interfaces.tariff.ITariffPreferenceCodeService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all TariffCountry for a dropdown/autocomplete list
            getDropdownList(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "TariffPreferenceCode/GetDropdownList", {
                    tariffCountryId: '@tariffCountryId'
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }
        }
    }
    angular.module("app").service("tariffPreferenceCodeService", services.tariff.tariffPreferenceCodeService);
}